module.exports = __webpack_public_path__ + "img/blog.0a75c4b8.webp";